import color from "./color";
import font from "./font";
import effects from "./effects";
import size from "./size";

const foundation = {
    color,
    font,
    effects,
    size,
};

export { color, font, effects, size };
export default foundation;